import { CustomProductSubscriptionDto } from "@aihCustomBlueprint/Handlers/AihCustomProductSubscribe/CustomProductSubscriptionDto";
import getDashboardPanels from "@aihCustomBlueprint/Store/Data/DashboardPanel/Handlers/GetDashboardPanels";
import getNotifications from "@aihCustomBlueprint/Store/Data/ProductNotification/Handlers/GetNotifications";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import { DashboardPanelCollectionModel, DashboardPanelModel, ProductDto } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import baseTheme from "@insite/mobius/globals/baseTheme";
import Check from "@insite/mobius/Icons/Check";
import File from "@insite/mobius/Icons/File";
import List from "@insite/mobius/Icons/List";
import Img from "@insite/mobius/Img";
import Link from "@insite/mobius/Link";
import Typography from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapDispatchToProps = {
    getDashboardPanels,
    getNotifications,
};

export interface MyAccountDashboardPanelsStyles {
    container?: InjectableCss;
    counterStyle?: InjectableCss;
    subCountDiv?: InjectableCss;
    imageContainer?: InjectableCss;
    subscriptText?: InjectableCss;
    subCountStyle?: InjectableCss;
    bottomTitle?: InjectableCss;
    linkIcon?: InjectableCss;
}

export const myAccountDashboardPanelsStyles: MyAccountDashboardPanelsStyles = {
    container: {
        css: css`
            margin: 0;
            float: left !important;
            position: relative;
            padding-bottom: 15px;
            padding-right: 0.9375rem;
            width: 100%;
            > ul {
                display: block;
                padding: 0;
                margin: 0 -0.625rem;
                a:hover + span {
                    -webkit-transform: translateY(-3px) translateX(-3px);
                    transform: translateY(-3px) translateX(-3px);
                }
                li {
                    display: block;
                    height: auto;
                    float: left;
                    padding: 0.625em;
                    position: relative;
                    ${({ theme }) => {
                        const { maxWidths } = theme.breakpoints || baseTheme.breakpoints;
                        return breakpointMediaQueries(theme, [
                            css`
                                width: 50%;
                            `,
                            css`
                                width: 50%;
                            `,
                            css`
                                width: 50%;
                            `,
                            css`
                                width: 33.33%;
                            `,
                            css`
                                width: 33.33%;
                            `,
                        ]);
                    }}
                    span {
                        transition: all 0.2s;
                    }
                    a {
                        list-style: none;
                        float: left;
                        position: relative;
                        top: 0;
                        border-bottom: 0;
                        padding: 0 !important;
                        background: #333;
                        white-space: nowrap;
                        min-height: 150px;
                        width: 100%;
                        text-align: left !important;
                        background: ${getColor("primary.main")};
                        border: 1px solid #707070;
                        text-decoration: none;
                        border-radius: 7px;
                        transition: all 0.2s;
                        :hover {
                            box-shadow: 1px 1px #ed1c24, 2px 2px #ed1c24, 3px 3px #ed1c24;
                            -webkit-transform: translateY(-3px) translateX(-3px);
                            transform: translateY(-3px) translateX(-3px);
                            opacity: 1;
                        }
                        span {
                            position: absolute;
                            bottom: 0;
                            left: 0;
                            width: 100%;
                            padding: 10px 0;
                            white-space: normal;
                            min-height: 2.5em;
                            color: #fff;
                            text-align: center;
                            font-size: 1.125rem;
                            padding-left: 0.25em;
                            padding-right: 0.25em;
                            font-weight: 700;
                            transition: all 0.2s;
                            :active {
                                text-decoration: none;
                            }
                        }
                    }
                }
            }
        `,
    },
    linkIcon: {
        css: css`
            text-align: center;
            width: 100%;
            margin-top: -45px;
            height: 45px;
            display: inline-block;
            font-family: "ISC-Dashboard-Icon-Pack";
            font-weight: normal;
            font-variant: normal;
            text-transform: none;
            line-height: 1;
            -webkit-font-smoothing: antialiased;
            color: #fff;
            top: 56%;
            position: absolute;
            padding: 0 !important;
            svg {
                height: 60px;
                width: 60px;
                color: white;
            }
        `,
    },
    subCountDiv: {
        css: css``,
    },
    subCountStyle: {
        css: css`
            font-weight: 700;
            position: relative !important;
            text-decoration: none !important;
            color: #fff;
            font-size: 25px !important;
            padding: 15px !important;
        `,
    },
    counterStyle: {
        css: css`
            position: absolute;
            top: 5%;
            left: 5%;
            display: block;
            color: #fff;
            font-size: 25px;
            padding: 10px;
            text-align: center;
            font-weight: 700;
            top: 0;
            left: 15px;
        `,
    },
    imageContainer: {
        css: css`
            display: flex;
            justify-content: center;
            height: 33.3%;
        `,
    },
    subscriptText: {
        css: css`
            color: #fff;
            font-weight: 700 !important;
            position: relative !important;
            text-decoration: none !important;
        `,
    },
    bottomTitle: {
        css: css`
            text-align: center;
            padding-top: 7%;
        `,
    },
};

const styles = myAccountDashboardPanelsStyles;

type Props = WidgetProps & ResolveThunks<typeof mapDispatchToProps>;
const MyAccountDashboardPanels = ({ getDashboardPanels, getNotifications }: Props) => {
    const [userSubscriptionCount, setUserSubscriptionCount] = useState<string>("0");
    const [panels, setPanels] = useState<DashboardPanelModel[]>([]);

    React.useEffect(() => {
        getDashboardPanels({
            onSuccess: (dashboardPanelCollection: DashboardPanelCollectionModel) => {
                const panels = dashboardPanelCollection?.dashboardPanels?.filter(x => {
                    return x.isPanel;
                });
                setPanels(panels ?? []);
            },
            onError: (message: string) => {},
        });
    }, []);
    React.useEffect(() => {
        getNotifications({
            onSuccess: (count: CustomProductSubscriptionDto[]) => {
                setUserSubscriptionCount(count.length.toString() ?? "0");
            },
            onError: (message: string) => {},
        });
    }, []);
    
    return (
        <StyledWrapper {...styles.container}>
            <ul>
                {panels.map((panel, i) => (
                    <li key={i}>
                        <Link
                            as="a"
                            href={panel.url}
                            icon={{
                                iconProps: {
                                    src:
                                        panel.panelType === "RequestForQuote"
                                            ? List
                                            : panel.panelType === "OrderApprovals"
                                            ? Check
                                            : panel.panelType === "Requisitions"
                                            ? File
                                            : "",
                                    ...styles.linkIcon,
                                },
                            }}
                        >
                            <Typography as="span">{panel.text}</Typography>
                        </Link>
                        <Typography as="span" {...styles.counterStyle}>
                            <Typography as="span">{panel.count}</Typography>
                        </Typography>
                    </li>
                ))}
                <li>
                    <a href="/MyAccount/ProductSubscriptionsPage">
                        <StyledWrapper {...styles.subCountDiv}>
                            <Typography as="span" {...styles.subCountStyle}>
                                {userSubscriptionCount}
                            </Typography>
                        </StyledWrapper>
                        <StyledWrapper {...styles.imageContainer}>
                            <Img
                                width={47}
                                height={50}
                                src="https://d3cacd5apmg13r.cloudfront.net/userfiles/theme/icon material-notifications-active.png"
                            />
                        </StyledWrapper>
                        <StyledWrapper {...styles.bottomTitle}>
                            <Typography as="span" {...styles.subscriptText}>
                                {translate("Product Subscriptions")}
                            </Typography>
                        </StyledWrapper>
                    </a>
                </li>
            </ul>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(null, mapDispatchToProps)(MyAccountDashboardPanels),
    definition: {
        allowedContexts: ["MyAccountPage"],
        group: "My Account",
        displayName: "Dashboard Panels",
    },
};

export default widgetModule;
